import type { PlanTermProps, PlanTermWorkingTimeProps } from '../context';
export const ONE_DAY = 2400;
export const EIGHT_TIME = 801;

export const validateWorkingTime = (
  data: PlanTermWorkingTimeProps,
  separate?: boolean,
):
  | {
      startTime: boolean;
      endTime: boolean;
      workingTime: boolean;
    }
  | boolean => {
  const isValidStartTime =
    data.startTimeText?.length === 5 &&
    convertToTome(data.startTimeText) < ONE_DAY;
  const isValidEndTime =
    data.endTimeText?.length === 5 &&
    convertToTome(data.startTimeText) < convertToTome(data.endTimeText);
  const isValidWorkingTime =
    data.workingTime?.length === 5 &&
    convertToTome(data.workingTime) < EIGHT_TIME;

  if (separate) {
    return {
      startTime: isValidStartTime,
      endTime: isValidEndTime,
      workingTime: isValidWorkingTime,
    };
  } else {
    return isValidStartTime && isValidEndTime && isValidWorkingTime;
  }
};

export const validateWorkingHour = (
  data: PlanTermProps,
  separate?: boolean,
):
  | {
      startTime: boolean;
      endTime: boolean;
      totalTimes: boolean;
    }
  | boolean => {
  const isValidStartTime =
    data.startTimeText?.length === 5 &&
    convertToTome(data.startTimeText) < ONE_DAY;
  const isValidEndTime =
    data.endTimeText?.length === 5 &&
    convertToTome(data.startTimeText) < convertToTome(data.endTimeText);
  const isValidTotalTimes =
    data.totalTimes?.length === 5 &&
    convertToTome(data.totalTimes) < EIGHT_TIME;

  if (separate) {
    return {
      startTime: isValidStartTime,
      endTime: isValidEndTime,
      totalTimes: isValidTotalTimes,
    };
  } else {
    return isValidStartTime && isValidEndTime && isValidTotalTimes;
  }
};

const convertToTome = (value: string) => {
  const [hours, minutes] = value.split(':');
  return Number(hours) * 100 + Number(minutes);
};
